// Copyright 2016 Sorama B.V.

import { IValueConverter } from "aurelia-binding-ext";
import { FrontEnd } from "datatypes/SoramaLocalApi";
import { NotSupportedError } from "errors/NotSupportedError";
import { IHardwareDevice } from "services/Hardware/Datatypes/IHardwareDevice";

export class HardwareDeviceToDescriptionValueConverter implements IValueConverter<string[], IHardwareDevice> {
    public toView(value: IHardwareDevice): string[] {
        const description: string[] = [];

        // FrontEnd hardware devices
        if (<FrontEnd>value != null && (<FrontEnd>value).frontEndConnectors) {
            for (let i = 0; i < (<FrontEnd>value).frontEndConnectors.length; i += 1) {
                description.push((<FrontEnd>value).frontEndConnectors[i].connectionInfo);
            }
        }

        return description;
    }

    public fromView(value: string[]): IHardwareDevice {
        throw new NotSupportedError("Conversion from description to IHardwareDevice is not supported.");
    }
}
